// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { TRANSPORTISTAS_API } from "../views/MainLayout/components/shared/services/transportistas";
import { makeSetReducer } from "./utils";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const transportistasFullfilledReducer = makeSetReducer(['transportistas/fullfilled']);

export const fetchTransportistas = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await TRANSPORTISTAS_API.get()
        const data = await response.data;
        dispatch({ type: 'transportistas/fullfilled', payload: data })
        const readOnly = JSON.parse(localStorage.getItem('read_only'));
        readOnly.transportistas = data;
        localStorage.setItem('read_only', JSON.stringify(readOnly));
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}